import React, { useState, useEffect } from "react"
import styled, { css } from "styled-components"
import { motion, AnimatePresence } from "framer-motion"

import Icon from "../global/icon"

const size = {
  tablet: 850,
  mini: 768,
  mobile: 600,
}
const below = Object.keys(size).reduce((acc, label) => {
  acc[label] = (...args) => css`
    @media (max-width: ${size[label]}px) {
      ${css(...args)};
    }
  `
  return acc
}, {})

const Card = styled(motion.div)`
  border: solid;
  border-width: 1px;
  border-color: var(--ice-grey);
  border-radius: 10px;
  padding: 24px;
  // max-width: 466px;
  margin-bottom: 64px;
  width: 100%;
  &.expandable {
    cursor: pointer;
  }
  &.expanded {
    border-color: #cbd2dd !important;
  }
  ${below.mini`
  max-width: initial;
  margin-bottom: 24px;
  `}
`

const Review = styled(motion.div)`
  font-size: 22px;
  line-height: 28px;
  color: var(--alt-black);
  margin: 16px 0;
  letter-spacing: 0.01rem;
  ${below.mobile`
  margin: 8px 0 16px;
  font-size: 16px;
    line-height: 20px;`}
`
const Reviewer = styled.div`
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
  text-align: right;
  letter-spacing: 0.01rem;

  color: var(--alt-black);
  &.expanded {
    color: ${props => props.reviewerColor || "#1A202C"};
  }
  ${below.mobile`
  font-size: 16px;
line-height: 20px;
  `}
`
const Source = styled.div`
  font-size: 16px;
  line-height: 20px;
  text-align: right;
  color: var(--grey);
  ${below.mobile`
  font-size: 14px;
line-height: 16px;
  `}
`
const ExpandIcons = styled.div`
  padding: 5px;
  svg {
    fill: black;
  }
  &.expanded {
    svg {
      width: 16px;
      height: 16px;
      .close-drawer {
        stroke: ${props => props.reviewerColor || "black"};
      }
    }
  }
`

const ReviewCard = props => {
  const [isExpandable, setExpandable] = useState(false)
  const [isExpanded, setExpanded] = useState(false)

  useEffect(() => {
    const excerptLength = props.excerpt ? props.excerpt.length : 0
    const reviewLength = props.review ? props.review.length : 0
    if (reviewLength > excerptLength) {
      setExpandable(true)
    }
  }, [props.review, props.excerpt])

  return (
    <Card
      onClick={() => isExpandable && setExpanded(!isExpanded)}
      className={`${isExpandable && "expandable"} ${isExpanded && "expanded"}`}
      initial={false}
      animate={{
        backgroundColor: isExpanded
          ? "rgba(248, 250, 252, 0)"
          : "rgba(248, 250, 252, 1)",
      }}
      layout
    >
      <motion.div animate={{ y: isExpanded ? "-44px" : 0 }} layout>
        {isExpanded ? (
          <Icon
            icon="quote-circle-40"
            backgroundColor={props.quoteColor}
            quoteColor="white"
          />
        ) : (
          <Icon
            icon="quote-new"
            backgroundColor={props.backgroundColor}
            quoteColor={props.quoteColor}
          />
        )}
      </motion.div>
      <AnimatePresence>
        {!isExpanded ? (
          <Review
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 0 }}
          >
            {props.excerpt && props.excerpt}
          </Review>
        ) : (
          <Review
            initial={{ opacity: 0, y: 0 }}
            animate={{ opacity: 1, y: "-44px" }}
            exit={{ opacity: 0, y: 0 }}
          >
            {props.review && props.review}
          </Review>
        )}
      </AnimatePresence>
      <motion.div
        animate={{
          y: isExpanded ? "-44px" : 0,
          marginBottom: isExpanded ? "-44px" : "0px",
        }}
        style={{ position: "relative" }}
        layout
      >
        <Reviewer
          className={isExpanded && "expanded"}
          reviewerColor={
            props.quoteColor === "#FFEA9D" ? "#1a202c" : props.reviewerColor
          }
        >
          {props.reviewer ? props.reviewer : ""}
        </Reviewer>
        <Source>
          {props.source
            ? props.source === "BirdEye" || props.source === "Experience"
              ? "Recent Homebuyer"
              : props.source
            : "Recent Homebuyer"}
        </Source>
        {isExpandable && (
          <ExpandIcons
            reviewerColor={props.reviewerColor}
            className={isExpanded ? "expanded" : ""}
            style={{ position: "absolute", bottom: 0 }}
          >
            {!isExpanded && (
              <Icon icon="openDrawer" height="14px" width="14px" />
            )}
            {isExpanded && <Icon icon="closeDrawer" />}
          </ExpandIcons>
        )}
      </motion.div>
    </Card>
  )
}

export default ReviewCard
